import {inject, Injectable} from '@angular/core';
import {Observable, of, shareReplay, tap} from 'rxjs';
import {QualityControllerService, Rule} from '../../api';

/**
 * Service to prefetch and cache Quality check rules.
 * Avoids redundant API calls when navigating back and forth between steps.
 */
@Injectable({providedIn: 'root'})
export class QualityRulesPrefetchService {
  private qualityControllerService = inject(QualityControllerService);

  private cache$: Observable<Rule[]> | null = null;
  private cachedRules: Rule[] | null = null;

  get isLoaded(): boolean {
    return this.cachedRules !== null;
  }

  prefetch(): void {
    if (this.cache$) {
      return;
    }
    this.cache$ = this.qualityControllerService.getRules().pipe(
      tap(rules => this.cachedRules = rules),
      shareReplay(1)
    );
    this.cache$.subscribe();
  }

  getRules(): Observable<Rule[]> {
    if (this.cachedRules) {
      return of(this.cachedRules);
    }
    if (this.cache$) {
      return this.cache$;
    }
    this.prefetch();
    return this.cache$!;
  }

  clear(): void {
    this.cache$ = null;
    this.cachedRules = null;
  }
}
